var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d57ea81e82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.441406 0.558594 L 331 0.558594 L 331 217.761719 L 0.441406 217.761719 Z M 0.441406 0.558594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b4c7150511"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.441406 0.558594 L 363 0.558594 L 363 217.761719 L 0.441406 217.761719 Z M 0.441406 0.558594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c7601935b3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 373,
    y: 0,
    height: 218
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1, 76)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c7601935b3)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.077318, 0, 0, 1.077318, 12.521401, 72.916649)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00173583 10.498217 L 193.614286 10.498217 ",
    stroke: "#002f7b",
    strokeWidth: 21,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d57ea81e82)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.85753, -0.652116, 0.652116, 0.85753, 81.075122, 176.167561)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.000390629 9.498431 L 148.527228 9.499812 ",
    stroke: "#002f7b",
    strokeWidth: 19,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, -1.077318, 1.077318, 0, 70.780133, 192.578734)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.000564888 10.501654 L 167.053214 10.501654 ",
    stroke: "#002f7b",
    strokeWidth: 21,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b4c7150511)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.853067, -0.657944, 0.657944, 0.853067, 109.90364, 192.470714)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.000674382 10.501557 L 137.62941 10.499432 ",
    stroke: "#002f7b",
    strokeWidth: 21,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-1.077318, 0.00000000188027, -0.00000000188027, -1.077318, 278.708999, 173.605492)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00179946 10.500639 L 106.962369 10.500639 ",
    stroke: "#002f7b",
    strokeWidth: 21,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, 1.077318, -1.077318, 0, 278.71275, 12.62143)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.000311766 10.498675 L 175.26501 10.498675 ",
    stroke: "#002f7b",
    strokeWidth: 21,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, 1.077318, -1.077318, 0, 316.418382, 63.917764)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.000190415 10.501002 L 119.437468 10.501002 ",
    stroke: "#002f7b",
    strokeWidth: 21,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-1.077318, -0.00000000188027, 0.00000000188027, -1.077318, 360.462159, 201.429259)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00113401 10.50022 L 61.891689 10.50022 ",
    stroke: "#002f7b",
    strokeWidth: 21,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.00000000188027, 1.077318, -1.077318, 0.00000000188027, 360.47505, 113.344606)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.000794553 10.499214 L 73.554294 10.499214 ",
    stroke: "#002f7b",
    strokeWidth: 21,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9ce24c68def4d86fc1acb0e65f20d147.svg";
export { ForwardRef as ReactComponent };